var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var Skillsets = require("lib/academic/Skillsets");
var AccountPlans = require("lib/account/AccountPlans");
var TextTypes = require("lib/academic/TextTypes");
var Formats = require("lib/academic/Formats");
var GradeLevel = require("lib/academic/GradeLevel.js");
var AltSkillsets = require("lib/academic/AltSkillsets");
var moment = require('moment');
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");

var DropDownOptions = {
	Select: {
		ReadingLevels(props) {
			if (props.lexile_to_formats) {
				var options = []
				var values = []

				if (props.lexile_to_formats == "Lexile Level") {
					for (var i = 0; i < 2201; i += 5) {
						// inject current reading level into dropdown if present
						if (props.current_reading_level) {
							var { current_reading_level } = props.current_reading_level
							if (current_reading_level && current_reading_level > i - 5 && current_reading_level < i) {
								options.push(<option value={current_reading_level} key={current_reading_level}>{current_reading_level}L</option>)
							}
						}
						options.push(<option value={ i } key={ i }>{ i }L</option>)
					}
				} else {
					_.each(ReadingLevelFormat.LEXILE_TO_FORMATS[props.lexile_to_formats], (label, lexile) => {
						if (label != "N/A" && lexile != "N/A" && !isNaN(parseInt(lexile)) && values.indexOf(label) == -1) {
							options.push(<option value={ lexile } key={ lexile }>{ label }</option>)
							values.push(label)
						}
					})
				}
				options.push(<option value={ -1 } key={"cancel"}>Cancel</option>)
				return options
			} else {
				return [];
			}
		},
		ExpectationPeriods(props) {
			var options = []
			_.each($wr.Constants.PERIODS, (label, key) => {
				if (props.filter == undefined || props.filter.indexOf(label) == -1) {
					options.push(
						<option value={ label } key={ key }>
							{ label }
						</option>
					);
				}
			})
			return options
		},
		RecallQuestionCount(props) {
			return [
				<option value={0} key={0}>0</option>,
				<option value={2} key={2}>2</option>,
				<option value={3} key={3}>3</option>,
				<option value={4} key={4}>4</option>,
				<option value={5} key={5}>5</option>,
			]
		},
		AnalysisQuestionCount(props) {
			return [
				<option value={1} key={1}>1</option>,
				<option value={2} key={2}>2</option>,
				<option value={3} key={3}>3</option>,
			]
		},
		SentenceStarter(props) {
			return [
				<option value={"On"} key={0}>On</option>,
				<option value={"Off"} key={1}>Off</option>,
			]
		},
		GradeLevels(props) {
			return [
				<option value='-1' key='PK'>PK</option>,
				<option value='0' key='K'>K</option>,
				<option value='1' key='1'>1st</option>,
				<option value='2' key='2'>2nd</option>,
				<option value='3' key='3'>3rd</option>,
				<option value='4' key='4'>4th</option>,
				<option value='5' key='5'>5th</option>,
				<option value='6' key='6'>6th</option>,
				<option value='7' key='7'>7th</option>,
				<option value='8' key='8'>8th</option>,
				<option value='9' key='9'>9th</option>,
				<option value='10' key='10'>10th</option>,
				<option value='11' key='11'>11th</option>,
				<option value='12' key='12'>12th</option>,
			]
		},
		ExpectationGradeLevels(props) {
			return [
				<option value='Mixed' key='Mixed'>All Levels</option>,
				<option value='-1' key='PK'>PK</option>,
				<option value='0' key='K'>K</option>,
				<option value='1' key='1'>1st</option>,
				<option value='2' key='2'>2nd</option>,
				<option value='3' key='3'>3rd</option>,
				<option value='4' key='4'>4th</option>,
				<option value='5' key='5'>5th</option>,
				<option value='6' key='6'>6th</option>,
				<option value='7' key='7'>7th</option>,
				<option value='8' key='8'>8th</option>,
				<option value='9' key='9'>9th</option>,
				<option value='10' key='10'>10th</option>,
				<option value='11' key='11'>11th</option>,
				<option value='12' key='12'>12th</option>,
			]
		},
		contestReadingMetrics(props) {
			return [
				<option value="minutes_read" key="minutes_read">Minutes Read</option>,
				<option value="pages_read" key="pages_read">Pages Read</option>,
				<option value="titles_read" key="titles_read">Titles Read</option>,
				<option value="verified_minutes_read" key="verified_minutes_read">Verified Minutes Read</option>,
				<option value="verified_pages_read" key="verified_pages_read">Verified Pages Read</option>
			]
		},
		contestWritingMetrics(props) {
			return [
				<option value="writing_count" key="writing_count">All Writing</option>,
				<option value="quiz_count" key="quiz_count">Quiz Completed</option>,
				<option value="quiz_passed_count" key="quiz_passed_count">Quiz Passed</option>,
				<option value="answers_count" key="answer_count">Answers</option>,
				<option value='reviews_count' key='reviews_count'>Reviews Completed</option>
			]
		},
		Titles(props) {
			return _.map($wr.Constants.BASE_TITLES, function(title) {
				return (
					<option value={ title } key={ title }>{ title }</option>
				)
			});
		},

		Months(props) {
			var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
				'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

			return _.map(months, function(month, i) {
				if (props && props.longForm) {
					var text = (i + 1) + " - " + month;
				} else if (props && props.monthNameOnly) {
					var text = month;
				} else {
					var text = i + 1;
				}
				return (
					<option value={ i + 1 } key={ i + 1 } >{ text }</option>
				)
			});
		},

		FutureYears(props) {
			props = props || {};

			var yearsForward = props.yearsForward || 25;
			var options = [];
			var year = parseInt($wr.momentInTimezone(new Date()).format("Y"));
			
			for (var i = 0; i < yearsForward; i++) {
				var thisYear = year + i;
				if (props.shortForm) {
					thisYear = thisYear % 100;
				}

				options.push(
					<option value={ thisYear } key={ thisYear } >{ thisYear }</option>
				);
			}
			return options;
		},

		LastWeekDays(props) {
			var options = [];

			if (props && props.days && parseInt(props.days) > 0) {
				var dayCount = parseInt(props.days);
			} else {
				var dayCount = 7;
			}

			for (var i = 0; i < dayCount; i++) {
				var thisDay = moment().subtract(i, 'days').format('YYYY-MM-DD');
				var dayOfWeek = moment().subtract(i, 'days').format('dddd');
				var displayDay = i + " " + $wr.pluralize("day", i) + " ago " + "(" + dayOfWeek + ")";
				if (i == 0) {
					var displayDay = "Today";
				}

				options.push(
					<option value={ thisDay } key={ thisDay } >{ displayDay }</option>
				);
			}
			return options;
		},
		
		OwlShopOpeningTimes() {
			var options = [];
			options.push(<option value={ "Always" } key={ "Always" } >{ "Always leave open" }</option>)
			options.push(<option value={ "Never" } key={ "Never" } >{ "Close permanently" }</option>)
			var DEFAULT_VALUE = "Always leave open"
			var OPTION_LABEL = "Open after "
			for (var h = 1; h < 8; h++) {
				var value = h + " PM"
				var text = "Open at " + value
				options.push(
					<option value={ value } key={ h } >{ text }</option>
				);
			}
			return options;
 		},

		 QuizClosingTimes(){
			var options = [];
			options.push(<option value={ "Never" } key={ "Never" } >{ "Never close" }</option>)
			options.push(<option value={ "Always" } key={ "Always" } >{ "Always closed" }</option>)
			for (var h = 1; h < 6; h++) {
				var value = h + " PM"
				var text = "Close at " + value
				options.push(
					<option value={ value } key={ h } >{ text }</option>
				);
			}
			return options;
		 },

		Time() {
			var outputOptions = []
			var hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
			
			_.each(hours, function(hour, i){
				for (var i = 0; i <= 3; i++) {
					var minutes = i * 15;
					var minutesString = $wr.padleft(minutes, 2);
					var outputTime = $wr.padleft(hour) + ":" + minutesString;
					var pmTime = (hour - 12) + ":" + minutesString;

					if (hour == 0) {
						var display = "12" + ":" + minutesString + " am";
						var value = "0" + outputTime + ":00";
					} else if (hour == 10 || hour == 11) {
						var display = outputTime + " am";
						var value = outputTime + ":00";
					} else if (hour < 12) {
						var display = outputTime + " am";
						var value = "0" + outputTime + ":00";
					} else if (hour == 12) {
						var display = outputTime + " pm";
						var value = outputTime + ":00";
					}
					else {
						var display = pmTime + " pm";
						var value = outputTime + ":00";
					}
					outputOptions.push(
						<option value={ value } key={ outputTime } >{ display }</option>
					);
				}
			})

			return outputOptions
		},	
		PaidPlanOptions(props) {
			return _.map(AccountPlans.PAID_PLANS, (planType) => {
				return (
					<option key={ planType } value={ planType }>
						{ AccountPlans.name(planType) }
					</option>
				);
			})
		},
		PaidPlanTrialOptions(props) {
			return _.map(AccountPlans.PAID_ANNUAL_PLANS, (planType) => {
				return (
					<option key={ planType } value={ planType + "-trial" }>
						Trial: { AccountPlans.name(planType) }
					</option>
				);
			})
		},

		Locations(props) {
			return [
				<option value='School' key='School'>School</option>,
				<option value='Home' key='Home'>Home</option>,
			];	
		},

		TextVarieties(props) {
			return _.map(_.pairs(TextTypes.Varieties.TYPES), function(pair) {
				return (
					<option value={ pair[0] } key={ pair[0] }>
						{ pair[1].name }
					</option>
				);
			});
		},

		DifferentiatedLearning(props) {
			return [
				<option value='true' key='true'>On</option>,
				<option value='false' key='false'>Off</option>,
			];
		},

		YesNo(props) {
			return [
				<option value='true' key='true'>Yes</option>,
				<option value='false' key='false'>No</option>,
			];
		},

		simpleText(props) {
			return _.map(props.options, (opText) => {
				return (
					<option value={ opText } key={ opText }>{ opText }</option>
				);
			});
		},
		GroupColors(props) {
			return [
				<option value="#32b3f6" key="Blue"></option>,
				<option value="#409e1a" key="Green"></option>,
				<option value="#e8cb3a" key="Yellow"></option>,
				<option value="#ca5f2b" key="Orange"></option>,
				<option value="#7f45b1" key="Purple"></option>,
			]
		},
		GroupIcons(props) {
			return [
				<option value="leaf" key="Leaf"></option>,
				<option value="tree-conifer" key="Pine"></option>,
				<option value="tree-deciduous" key="Maple"></option>,
				<option value="cloud" key="Cloud"></option>,
				<option value="fire" key="Fire"></option>,
			]
		},
	},

	Button: {
		GradeLevels(props) {
			props = props || {};
			var buildF = props.buildOptionF || _.identity;
			var options = [];

			for (var i = -1; i <= 13; i++) {
				var text;
				if (i == -1) {
					text = "PK";
				} else if (i == 0) {
					text = "K";
				} else if (i == 13) {
					text = "Mixed";
				} else {
					text = $wr.getOrdinal(i);
				}
				options.push(<ButtonDropdownOption onClick={ buildF(i) }
					text={ text } key={ i } />);
			}
			return options;
		},

		Skillsets(props) {
			props = props || {};
			var buildF = props.buildOptionF || ((x) => { _.identity });

			var options = [];
			if (props.allOption) {
				options.push(
					<ButtonDropdownOption onClick={ buildF(null) }
						text={ "All skill sets" } key="all" />
				);
			}

			var pairs = _.sortBy(_.pairs(Skillsets.TYPES), function(pair) {
				return pair[1].name;
			});

			// Optional filter for fiction only or non-fiction only skill sets
			if (props.fictionOnly) {
				pairs = _.filter(pairs, function(pair) {
					return Skillsets.hasFiction(pair[0]);
				});
			} else if (props.nonFictionOnly) {
				pairs = _.filter(pairs, function(pair) {
					return Skillsets.hasNonFiction(pair[0]);
				});
			}

			if (props.readingOnly) {
				pairs = _.filter(pairs, function(pair) {
					return Skillsets.isReading(pair[0]);
				});
			}

			if (props.ogReadingOnly) {
				pairs = _.filter(pairs, function(pair) {
					return Skillsets.isOgReading(pair[0]);
				});
			}

			if (props.writingOnly) {
				pairs = _.filter(pairs, function(pair) {
					return Skillsets.isWriting(pair[0]);
				});
			}

			_.each(pairs, function(pair) {
				options.push(
					<ButtonDropdownOption onClick={ buildF(pair[0]) } key={ pair[0] }
						value={ pair[0] } text={ pair[1].name } />
				);
			});

			return options;
		},

		Grades(props) {
			props = props || {};
			var buildF = props.buildOptionF || _.identity;

			var options = [];
			if (props.allOption) {

				options.push(
					<ButtonDropdownOption onClick={ buildF(null) } text={ "All grades" } key="all" />
				);
			}

			_.each(_.pairs(GradeLevel.TYPES), function(pair) {
				options.push(
					<ButtonDropdownOption onClick={ buildF(pair[0]) } key={ pair[0] }
						text={ GradeLevel.getName(pair[0]) } />
				);
			});

			return options;
		},

		Formats(props) {
			props = props || {};
			var buildF = props.buildOptionF || _.identity;

			var options = [];
			if (props.allOption) {
				options.push(
					<ButtonDropdownOption onClick={ buildF(null) }
						text={ "All formats" } key="all" />
				);
			}
			_.each(_.pairs(Formats.TYPES), function(pair) {
				options.push(
					<ButtonDropdownOption onClick={ buildF(pair[0]) }
						text={ pair[1].name } key={ pair[0] } />
				);
			});

			return options;
		},

		TextVarieties(props) {
			props = props || {};

			var options = [];

			if (props.anyOrSpecific) {
				var keys = [TextTypes.Varieties.FICTION_AND_NON_FICTION,
					TextTypes.Varieties.SPECIFIC_TEXT]
			} else {
				var keys = _.keys(TextTypes.Varieties.TYPES);
				if (props.altOptions) {
					keys.push(TextTypes.Varieties.SPECIFIC_TEXT);
				}				
			}

			_.each(keys, function(key) {

				if (props.buildOptionF) {
					var onClick = props.buildOptionF(key);
				} else if (props.onClick) {
					var onClick = () => { props.onClick(key) };
				} else {
					var onClick = _.identity;
				}


				if (props.altOptions || props.anyOrSpecific) {
					var name = TextTypes.Varieties.getAltName(key);
				} else {
					var name = TextTypes.Varieties.getName(key);
				}				

				options.push(
					<ButtonDropdownOption onClick={ onClick } text={ name }
						className={ props.className } key={ key } />
				);
			});

			return options;
		},

		Students(props) {
			props = props || {};
			var buildF = props.buildOptionF || _.identity;

			var options = [];

			_.each(props.students, function(student) {
				options.push(
					<ButtonDropdownOption onClick={ buildF(student) }
						text={ student.display_name } key={ student.id } />
				);
			});

			return options;
		},

		Standards(props) {
			props = props || {};
			var buildF = props.buildOptionF || _.identity;

			var options = [];
			var standardPairs = _.sortBy(_.pairs(AltSkillsets.STANDARDS), function(pair) {
				if (pair[0] == "wrss") {
					return "AA0";
				} else if (pair[0] == "ccss") {
					return "AA1";
				} else {
					return pair[1].state;
				}
			});

			_.each(standardPairs, function(pair) {
				var optionText = pair[1].name;
				if (props.showState && pair[1].state) {
					optionText += " (" + pair[1].state + ")";
				}
				options.push(
					<ButtonDropdownOption onClick={ buildF(pair[0]) }
						text={ optionText } key={ pair[0] } />
				);
			});

			return options;
		},

		DaysOfWeek(props) {
			props = props || {};
			var buildF = props.buildOptionF || _.identity;

			var options = [];

			for (var i = 0; i < 7; i++) {
				var displayText = $wr.getDayOfWeek(i);
				if (props.includeWeeklyRange) {
					displayText += " - " + $wr.getDayOfWeek((i + 6) % 7);
				}
				options.push(
					<ButtonDropdownOption onClick={ buildF(i) }
						text={ displayText } key={ i } />
				);
			}

			return options;
		},

		simpleText(props) {
			return _.map(props.options, (opText) => {
				return (
					<ButtonDropdownOption text={ opText } key={ opText }
						onClick={ (e) => props.onClick(opText) } />
				);
			});
		},
	}
}

module.exports = DropDownOptions;


// WEBPACK FOOTER //
// ./modules/components/utility/DropDownOptions.js